import { HeaderMenu } from "./modules/HeaderMenu";
import { HeaderEntry } from "./modules/HeaderEntry";
import { ClassToggle } from "./modules/ClassToggle";
import { ClassPageTop } from "./modules/ClassPageTop";
import { ClassPageLink } from "./modules/ClassPageLink";
import { ClassTab } from "./modules/ClassTab";
import { ClassMotionCss } from "./modules/ClassMotionCss";
import { ClassScroll } from "./modules/ClassScroll";
import { HeaderMega } from "./modules/HeaderMega";

document.addEventListener("DOMContentLoaded", function () {
  const headerMenu = new HeaderMenu();
  const headerEntry = new HeaderEntry();

  const toggle = new ClassToggle();
  const pageTop = new ClassPageTop();
  const pageLink = new ClassPageLink();
  const headerMega = new HeaderMega();
  const tab = new ClassTab();
  const motionCss = new ClassMotionCss();
  const scroll = new ClassScroll();

  if (!document.body.classList.contains("page-index")) {
    motionCss.excute();
  }
});
